import { render, staticRenderFns } from "./activityform.vue?vue&type=template&id=9c6d9d7a&"
import script from "./activityform.vue?vue&type=script&lang=js&"
export * from "./activityform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports